module.exports = __webpack_public_path__ + "img/1548365013.c280f218.jpg";